import Modal from "./Base/Modal";
import { FiInfo, FiX } from "react-icons/fi";
import {TransactionI} from "../interfaces";
import {format, parseISO} from "date-fns";
import {formatCurrency} from "../utils";

interface PropsI {
    showModal: boolean;
    onClose : ()=>void;
    transaction: TransactionI;
}

const TransactionSummaryModal = ({ showModal, onClose, transaction }: PropsI) => {
    return (
        <Modal
            showModal={showModal}
            onClose={onClose}
            className="transaction-summary-modal"
        >
            <div className="modal-head">
                <div className="flex items-center">
                    <FiInfo className="mr-3 text-2xl font-semibold" />
                    Transaction Summary
                </div>
                <button className="btn btn-text" onClick={onClose}>
                    <FiX className="text-3xl" />
                </button>
            </div>
            <div className="modal-body">
                <ul className="modal-items">
                    <li className="modal-item">
                        <span className="modal-item-left">PIN</span>
                        <span className="modal-item-right">{}</span>
                    </li>
                    <li className="modal-item">
                        <span className="modal-item-left">Description</span>
                        <span className="modal-item-right">{transaction.description}</span>
                    </li>
                    <li className="modal-item">
                        <span className="modal-item-left">Posting Date</span>
                        <span className="modal-item-right">{transaction.contributionDate ? format(parseISO(transaction.contributionDate), 'yyyy-MM-dd') : ""}</span>
                    </li>
                    <li className="modal-item">
                        <span className="modal-item-left">Employer Contribution</span>
                        <span className="modal-item-right">{formatCurrency(transaction.employerContribution)}</span>
                    </li>
                    <li className="modal-item">
                        <span className="modal-item-left">Employee Contribution</span>
                        <span className="modal-item-right">{formatCurrency(transaction.employeeContribution)}</span>
                    </li>
                    <li className="modal-item">
                        <span className="modal-item-left">Voluntary</span>
                        <span className="modal-item-right">{formatCurrency(transaction.voluntaryContribution)}</span>
                    </li>
                    <li className="modal-item">
                        <span className="modal-item-left">Admin Fee</span>
                        <span className="modal-item-right">{formatCurrency(transaction.fee)}</span>
                    </li>
                    <li className="modal-item">
                        <span className="modal-item-left">RSA Withdrawal</span>
                        <span className="modal-item-right">{formatCurrency(transaction.withdrawal)}</span>
                    </li>
                    <li className="modal-item">
                        <span className="modal-item-left">VC Withdrawal</span>
                        <span className="modal-item-right">{formatCurrency(transaction.withdrawalFromVoluntary)}</span>
                    </li>
                    <li className="modal-item">
                        <span className="modal-item-left">NSITF</span>
                        <span className="modal-item-right">N/A</span>
                    </li>
                    <li className="modal-item">
                        <span className="modal-item-left">Total</span>
                        <span className="modal-item-right">{transaction.totalContribution}</span>
                    </li>
                    <li className="modal-item">
                        <span className="modal-item-left">Units</span>
                        <span className="modal-item-right">N/A</span>
                    </li>
                    <li className="modal-item">
                        <span className="modal-item-left">Narration</span>
                        <span className="modal-item-right">{transaction.narration}</span>
                    </li>
                </ul>
            </div>
        </Modal>
    )
}

export default TransactionSummaryModal;